import React, { useState } from "react";
import { Menu, Submenu, Item, useContextMenu } from "react-contexify";
import { notify } from "../../generic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faCircle } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tippy";

function FrequenceButton({
  fournisseurs,
  transaction,
  updateFrequenceAction,
  utilisateurId,
  entreprise,
  refetchAction,
  addedFournisseurs = [],
  selectedFournisseur = {}
}) {
  const [buttonActive, setButtonActive] = useState(false); // correspond à un identfiant de compte, sinon null
  const { frequence, id: transactionId } = transaction;
  let { fournisseur } = transaction;
  if (selectedFournisseur.value) fournisseur = selectedFournisseur;

  let displayFrequence = frequence || "Ponctuel";

  const items = [
    { recurrence: "daily", label: "Quotidien" },
    { recurrence: "weekly", label: "Hebdomadaire" },
    { recurrence: "monthly", label: "Mensuel" },
    { recurrence: "bimonthly", label: "Bimestriel" },
    { recurrence: "quarterly", label: "Trimestriel" },
    { recurrence: "annual", label: "Annuel" }
  ];

  const filteredFrequence = items.filter(freq => freq.recurrence === frequence);

  if (filteredFrequence.length)
    displayFrequence = filteredFrequence[0].label || "Ponctuel";

  const MENU_ID = `menu-${transactionId}`;

  const { show } = useContextMenu({
    id: MENU_ID
  });

  const handleItemClick = ({
    event,
    props,
    triggerEvent,
    data,
    fournisseurs,
    addedFournisseurs,
    selectedFournisseur
  }) => {
    let fournisseurId = null;
    let name;

    const matchingFournisseur = [...fournisseurs, ...addedFournisseurs].filter(
      fo => fo.value === transaction.fournisseur
    );

    console.log(matchingFournisseur);
    name = matchingFournisseur.length ? matchingFournisseur[0].label : "";

    if (!name && selectedFournisseur.value) {
      name = selectedFournisseur.label;
      fournisseurId = selectedFournisseur.value;
    }

    if (!name) return;

    updateFrequenceAction({
      utilisateurId,
      name: name,
      cleanDescription: transaction.cleanDescription,
      fournisseurId,
      entreprise,
      montant: transaction.montant,
      frequencyType: data,
      referenceDate: transaction.date,
      refetch: refetchAction
    });
  };

  const displayMenu = e => {
    if (fournisseur) {
      // put whatever custom logic you need
      // you can even decide to not display the Menu
      show(e, {
        position: {
          x: e.pageX - 180,
          y: e.pageY
        }
      });
      setButtonActive(true);
    } else {
      notify(
        "error",
        "Vous devez spécifier un fournisseur/client pour associer une récurrence"
      );
    }
  };

  const handleContextMenuAction = e => {
    handleItemClick({
      ...e,
      addedFournisseurs,
      selectedFournisseur,
      fournisseurs
    });
  };

  const menu = (
    <Menu id={MENU_ID} onHidden={() => setButtonActive(false)}>
      <Submenu
        label={
          <>
            <FontAwesomeIcon icon={faCircle} size={"xs"} color="#677F62" />
            &nbsp;Récurrent
          </>
        }
        arrow={<FontAwesomeIcon icon={faChevronRight} />}
      >
        {items.map(({ recurrence, label }) => (
          <Item data={recurrence} onClick={e => handleContextMenuAction(e)}>
            {label}
          </Item>
        ))}
      </Submenu>
      <Item data="unique" onClick={handleItemClick}>
        <FontAwesomeIcon icon={faCircle} size={"xs"} color="gray" />
        &nbsp;Unique
      </Item>
    </Menu>
  );

  const colFrequencesClasses = ["colFrequence"];
  if (buttonActive) colFrequencesClasses.push("active");
  if (!fournisseur) colFrequencesClasses.push("disabled");

  return (
    <>
      <div className={colFrequencesClasses.join(" ")} onClick={displayMenu}>
        <Tooltip
          // options
          title="Fréquence"
          position="bottom"
          size="small"
        >
          <span className="freqTitle">{displayFrequence}</span>
          <div className="freqBackground"></div>{" "}
        </Tooltip>
      </div>
      {menu}
    </>
  );
}

export default FrequenceButton;
